import { gql } from '@apollo/client';
import React from 'react';

import { CSPProductFamilyCTAData } from '../../../schemas/rql';
import { ProductFamilyCTA } from '../../product_family_cta';

export const CSPProductFamilyCTAFragment = gql`
  fragment CSPProductFamilyCTAData on CSP {
    _id
    # Alias this image as it could conflict with other CSP images fetched.
    productFamilyCalloutImage: image(input: { transform: "card_square", count: 1 }) {
      source
    }
    specs {
      productSpecs {
        _id
        type
        name
        value
        path
      }
    }
  }
`;

interface IProps {
  csp: CSPProductFamilyCTAData.Fragment;
}

export function CSPProductFamilyCTA(props: IProps) {
  const productSpecs = props.csp?.specs?.productSpecs || [];
  const image = props.csp?.productFamilyCalloutImage?.source;

  return (
    <ProductFamilyCTA
      productSpecs={productSpecs}
      thumbnailImage={image}
    />
  );
}
